function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCharacterInfo = function SvgCharacterInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54041",
    transform: "translate(-234 -4452)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1876",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(234 4452)",
    style: {
      fill: "#b0dfff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25958",
    d: "M14.867 25.777h-1.934v-7.733H11M12.933 12h.019",
    transform: "translate(233.377 4444.769)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })));
};

export default SvgCharacterInfo;